export const toTrimmedString = (value) => {
    if (typeof value === 'string') return value.trim();
    if (value == null) return '';
    return String(value).trim();
};

export const capitalizeNamePart = (value) => {
    const trimmed = toTrimmedString(value);
    if (!trimmed) return '';
    const [firstChar, ...restChars] = Array.from(trimmed);
    return firstChar.toUpperCase() + restChars.join('');
};

export const capitalizeWords = (value) => {
    const trimmed = toTrimmedString(value);
    if (!trimmed) return '';
    return trimmed
        .split(/\s+/)
        .map(capitalizeNamePart)
        .filter(Boolean)
        .join(' ');
};

export const formatFullName = (first, last) => {
    const formattedFirst = capitalizeNamePart(first);
    const formattedLast = capitalizeNamePart(last);
    return [formattedFirst, formattedLast].filter(Boolean).join(' ').trim();
};

export const formatWithLastInitial = (first, last) => {
    const formattedFirst = capitalizeNamePart(first);
    const formattedLast = capitalizeNamePart(last);
    const [lastInitial] = Array.from(formattedLast);
    const initial = lastInitial ? `${lastInitial.toUpperCase()}.` : '';
    return [formattedFirst, initial].filter(Boolean).join(' ').trim();
};
